import { type Translationtype } from "utils";
import Link from "next/link";

interface IMagicAiNotPurchasedBannerProps {
  t: Translationtype;
}

export function MagicAiNotPurchasedBanner({
  t,
}: IMagicAiNotPurchasedBannerProps) {
  return (
    <div className="bg-yellow-100 border-l-4 border-yellow-500 text-yellow-800 p-4 mb-4 rounded-r-lg flex items-center justify-between gap-4">
      <div>
        <p className="text-sm font-semibold">
          {t("Reservation.magicAiNotPurchasedTitle")}
        </p>
        <p className="text-sm">
          {t("Reservation.magicAiNotPurchasedDescription")}
        </p>
      </div>
      <Link
        href="/manageMagicAI"
        className="ml-4 bg-yellow-500 hover:bg-yellow-600 text-white font-semibold px-4 py-2 rounded-full text-sm whitespace-nowrap"
      >
        {t("Global.activateMagicAI")}
      </Link>
    </div>
  );
}
